import { getProductFormField } from '../utils';
import Component from './ProductFormComboRadio';
import { injectIntl } from 'react-intl';

export default getProductFormField(injectIntl(Component));
